// src/components/store/sections/testimonials/TestimonialV69PodiumstarsSunsetAmber.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV69PodiumstarsSunsetAmber(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={69}
      archKey="podium_stars"
      archLabel="5-Star Podium Showcase"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
